import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, viewChildren } from "@angular/core";

import { FilterBar } from "../../../../common/filter-bar/filter-bar";

@Component({
  selector: "malfunction-filter-impact",
  templateUrl: "malfunction-filter-impact.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilterBar, TranslatePipe],
})
export class MalfunctionFilterImpact {
  private filterBarChildren = viewChildren(FilterBar);

  reset() {
    this.filterBarChildren().forEach((fb) => fb.reset());
  }
}
